import urlObj from './baseUrl'

const api = {
  getNetworkInfo: urlObj.baseURL + '/getNetworkInfo', //获取网点信息
  addLie: urlObj.baseURL + '/addLie', //点赞操作
  getPrizeList: urlObj.baseURL + '/getPrizeList', //获取奖品列表
  ocrVehicle: urlObj.baseURL + '/ocrVehicle', //行驶证识别
  ocrVehicleWechat: urlObj.baseURL + '/ocrVehicleWechat', //行驶证识别，微信上传方式
  ocrDriverLicense: urlObj.baseURL + '/ocrDriverLicense', //驾驶证识别
  ocrDriverLicenseWechat: urlObj.baseURL + '/ocrDriverLicenseWechat', //驾驶证识别，微信上传方式
  addReceiveRecord: urlObj.baseURL + '/addReceiveRecord', //添加领取奖品记录
  whetherLike: urlObj.baseURL + '/whetherLike', //查询是否已点赞
  endRegister: urlObj.baseURL + '/endRegister', //注册接口
  getLikeRanking: urlObj.baseURL + '/getLikeRanking', //获取点赞排行
  checkwhether: urlObj.baseURL + '/checkwhether', //查询是否已签到
  getUserInfo: urlObj.baseURL + '/getUserInfo', //获取用户信息
  checkin: urlObj.baseURL + '/checkin', //签到
  getRecordList: urlObj.baseURL + '/getRecordList', //获取积分列表
  getCheckList: urlObj.baseURL + '/getCheckList', //签到时间轴
  getNewIntegral: urlObj.baseURL + '/getNewIntegral', //获取最新积分
  getLotteryRule: urlObj.baseURL + '/getLotteryRule', //获取规则
  get_rand: urlObj.baseURL + '/get_rand', //抽奖
  getAwardRecord: urlObj.baseURL + '/getAwardRecord', //获取获奖记录
  receivePrize: urlObj.baseURL + '/receivePrize', //领取奖品
  getLastDay: urlObj.baseURL + '/getLastDay', //获取当前时间
  whetherReceivePrize: urlObj.baseURL + '/whetherReceivePrize', //判断是否已领奖
  confirmVehicleInfo: urlObj.baseURL + '/confirmVehicleInfo', //行驶证信息确认
  confirmDriverInfo: urlObj.baseURL + '/confirmDriverInfo', //驾驶证信息确认
  whetherRegisterEnd: urlObj.baseURL + '/whetherRegisterEnd', //判断是否已注册
  buildConfig: urlObj.baseURL + '/buildConfig', //微信config
  downloadImage: urlObj.baseURL + '/downloadImage', //微信config
  whetherVehicle: urlObj.baseURL + '/whetherVehicle', //判断行驶证是否上传
  whetherDriverLicense: urlObj.baseURL + '/whetherDriverLicense', //判断驾驶证是否上传
  getContactInfo: urlObj.baseURL + '/getContactInfo', //获取用户联系信息
  getVehicleAndDriverInfo: urlObj.baseURL + '/getVehicleAndDriverInfo', //获取驾驶证行驶证确认信息
  ocrProductBarcode: urlObj.baseURL + '/ocrProductBarcode', //上传识别产品序列号图片

  getAddressList: urlObj.URLEnduser + '/getAddressList', //获取地址列表
  createAddress: urlObj.URLEnduser + '/createAddress', //添加收货地址
  updateAddress: urlObj.URLEnduser + '/updateAddress', //编辑收货地址
  deleteAddress: urlObj.URLEnduser + '/deleteAddress', //删除收货地址
  getRecordIntegral: urlObj.URLEnduser + '/getRecordList', //兑换记录列表
  getRecordDetail: urlObj.URLEnduser + '/getRecordDetail', //兑换记录详情
  getCouponList: urlObj.URLEnduser + '/getCouponList', //获取卡券列表
  getCouponDetail: urlObj.URLEnduser + '/getCouponDetail', //获取卡券详情
  ConfirmReceipt: urlObj.URLEnduser + '/ConfirmReceipt', //确认收货

  getBannerList: urlObj.URLIntegral + '/getBannerList', //获取banner
  getBulletinList: urlObj.URLIntegral + '/getBulletinList', //获取公告
  getCategoryList: urlObj.URLIntegral + '/getCategoryList', //获取分类列表
  getGoodsList: urlObj.URLIntegral + '/getGoodsList', //获取商品列表
  getGoodsDetail: urlObj.URLIntegral + '/getGoodsDetail', //获取商品详情
  createOrder: urlObj.URLIntegral + '/createOrder', //创建订单

  weChat: urlObj.weChat + '/weChat/getJssdkConfig', //终端微信config

  getDealerInfo: urlObj.domainName + '/api/enduser/getDealerInfo', //终端获取网点信息

  listGoods: urlObj.domainName + '/api/enduser/listGoods', //终端获取商品列表

  detailGoods: urlObj.domainName + '/api/enduser/detailGoods', //终端获取商品详情

  addorder: urlObj.domainName + '/api/enduser/addorder', //终端下单

  detailOrder: urlObj.domainName + '/api/enduser/detailOrder', //终端订单详情

  detailOrder: urlObj.domainName + '/api/enduser/detailOrder', //终端订单详情

  listOrder: urlObj.domainName + '/api/enduser/listOrder', //终端订单列表

  wechatPay: urlObj.domainName + '/api/enduser/wechatPay', //终端-获取支付参数

  getJssdkConfig: urlObj.domainName + '/api/wechat/getJssdkConfig', //终端-获取微信配置参数
  agreement: urlObj.weChat + '/enduser/isagreement',
}

export default api



// WEBPACK FOOTER //
// ./src/axios/api.js